import { connect } from 'react-redux';
import DateAndTime from 'views/dateAndTime/DateAndTime';
import { dateTimeSettingRequest, updateDateTimeSettingRequest } from 'store/actions/general.actions';
import {
  getSaving,
  getDateTimeSetting,
  getUpdatedDateTimeSetting,
  getGeneralError,
} from 'store/selector/general.selector';

const mapDispatchToProps = {
  getSettingRequest: dateTimeSettingRequest,
  updateSetting: updateDateTimeSettingRequest,
};

const mapStateToProps = (state: any) => {
  const saving = getSaving(state);
  const setting = getDateTimeSetting(state);
  const settingSuccess = getUpdatedDateTimeSetting(state);
  const settingError = getGeneralError(state);
  return {
    saving,
    setting,
    settingSuccess,
    settingError,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DateAndTime);
